// extracted by mini-css-extract-plugin
export var badge = "Badge-module--badge--d1353";
export var badgeHighlight = "Badge-module--badge--highlight--503a5";